import { z } from "zod";
import { channelCannotOpenSchema } from "./resource-references.js";
/** Explicit sharing grants channel readers read access to a session only. */
export const sessionLinkInputSchema = z.object({
    channelId: z.string().trim().min(1).max(200),
}).strict().meta({ title: "SessionLinkInput" });
export const attachSessionResponseSchema = z.object({
    attached: z.boolean(),
    /** Sharing a session shares its conversation; its documents and files that some readers still cannot open are named here. */
    channelCannotOpen: channelCannotOpenSchema.meta({ title: "ChannelCannotOpen" }).optional(),
}).strict().meta({ title: "AttachSessionResponse" });
export const detachSessionResponseSchema = z.object({ detached: z.boolean() }).strict().meta({ title: "DetachSessionResponse" });
